import React, { useEffect, useState } from "react";
import {
  getVideoReport,
  deleteVideoReport,
  ingnoreVideoReport,
} from "../../store/report/report.action";
import Button from "../../Component/Common/Button";
import { connect, useDispatch, useSelector } from "react-redux";
import Pagination from "../../Component/Common/Pagination";
import Table from "../../Component/Common/Table";
import { covertURl } from "../../util/AwsFunction";
import dayjs from "dayjs";
import UserImage from "../../assets/images/noimage.png";
import { warning } from "../../util/Alert";
import DataActions from "../../Component/Common/DataActions";

function VideoReport(props) {
  const { videoReport, totalVideoReport } = useSelector(
    (state) => state.report,
  );
  const { startDate, endDate } = props;

  const dispatch = useDispatch();
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [showImg, setShowImg] = useState();
  const [actionPagination, setActionPagination] = useState("");
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [debounceSearchText, setDebounceSearchText] = useState("");

  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };

  useEffect(() => {
    dispatch(
      getVideoReport({
        page,
        limit: size,
        startDate,
        endDate,
        videoType: 1,
        searchText: debounceSearchText,
      }),
    );
  }, [dispatch, page, size, startDate, endDate, debounceSearchText]);

  useEffect(() => {
    setData(videoReport);
  }, [videoReport]);

  // Debouncing for search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setDebounceSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const handleIgnoreUser = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            dispatch(ingnoreVideoReport(id, "videoreport"));
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const videoReportTable = [
    {
      Header: (
        <input
          type="checkbox"
          checked={selectAllChecked}
          onChange={handleSelectAll}
        />
      ),
      width: "20px",
      Cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectCheckData.some(
            (selectedRow) => selectedRow?._id === row?._id,
          )}
          onChange={(e) => handleSelectCheckData(e, row)}
        />
      ),
    },
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "CHANNEL NAME",
      body: "fullName",
      Cell: ({ row }) => (
        <span className="text-capitalize text-nowrap">{row?.fullName}</span>
      ),
    },
    {
      Header: "VIDEO ID",
      body: "uniqueVideoId",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.uniqueVideoId}</span>
      ),
    },
    {
      Header: "VIDEO IMAGE",
      body: "image",
      Cell: ({ row, index }) =>
        showImg ? (
          <img
            src={showImg[index]}
            width="48px"
            height="48px"
            style={{ objectFit: "cover" }}
            onError={(e) => {
              e.target.src = UserImage;
            }}
          />
        ) : (
          ""
        ),
    },

    {
      Header: "VIDEO TITLE",
      body: "videoTitle",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.videoTitle}</span>
      ),
    },
    {
      Header: "VIDEO REPORT TYPE",
      body: "reportType",
      Cell: ({ row }) => (
        <>
          {row?.reportType === 1 && (
            <span className="text-capitalize">Sexual</span>
          )}
          {row?.reportType === 2 && (
            <span className="text-capitalize">Violent or Replusive</span>
          )}
          {row?.reportType === 3 && (
            <span className="text-capitalize">Hateful or Abusive</span>
          )}
          {row?.reportType === 4 && (
            <span className="text-capitalize">Harmful or Dangerous</span>
          )}
          {row?.reportType === 5 && (
            <span className="text-capitalize">Spam or Misleading</span>
          )}
          {row?.reportType === 6 && (
            <span className="text-capitalize">Child abuse</span>
          )}
          {row?.reportType === 7 && (
            <span className="text-capitalize">Others</span>
          )}
        </>
      ),
    },
    {
      Header: "VIDEO REPORTED",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.createdAt ? dayjs(row?.createdAt).format("DD MMMM YYYY") : ""}
        </span>
      ),
    },
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) => (
        <div className="action-button d-flex align-items-center">
          <Button
            className={`fw-bolder bg-success text-white w-70 py-0`}
            onClick={() => handleIgnoreUser(row)}
          >
            Ignore
          </Button>

          <Button
            className={`fw-bolder text-white w-70 py-0`}
            onClick={() => handleDeleteUser(row)}
            style={{ backgroundColor: "#FF1010" }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchData();
  }, [data]);

  const fetchData = async () => {
    if (!data || data.length === 0) {
      // Handle case when data is undefined or empty
      return;
    }

    const urls = await Promise.all(
      data?.map(async (item) => {
        const fileNameWithExtension = item?.videoImage?.split("/").pop();
        const { imageURL } = await covertURl(
          "videoImage/" + fileNameWithExtension,
        );

        return imageURL;
      }),
    );
    setShowImg(urls);
  };
  const handleSelectCheckData = (e, row) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectCheckData((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      setSelectCheckData((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id),
      );
    }
  };

  const paginationSubmitButton = () => {
    const selectCheckDataGetId = selectCheckData?.map((item) => item?._id);
    if (actionPagination === "delete") {
      const data = warning();
      data
        .then((res) => {
          const yes = res.isConfirmed;
          if (yes) {
            if (res) {
              props.deleteVideoReport(selectCheckDataGetId);
            }
          }
        })
        .catch((err) => console.log(err));
    }

    setActionPagination("");
    setSelectCheckData([]);
    setSelectAllChecked(false);
  };
  const handleDeleteUser = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            props.deleteVideoReport(id, "user");
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  return (
    <div className="userPage p-0 mb-3">
      <div className="payment-setting-box user-table ">
        <div className="user-table-top">
          <div className="mb-3">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "5px",
                marginTop: "5px",
                padding: "3px",
              }}
            >
              Video Report Table
            </h5>
          </div>

          <DataActions
            searchInputProps={{
              placeholder: "Search for ID, Name, Email",
              value: searchText,
              onValueChange: (value) => setSearchText(value),
            }}
            showActionOptions={true}
            dropdownProps={{
              value: actionPagination,
              options: [
                {
                  label: "Delete",
                  value: "delete",
                },
              ],
              onChange: (value) => setActionPagination(value),
            }}
            actionButtonProps={{
              disabled: !actionPagination && !selectCheckData.length,
              onClick: paginationSubmitButton,
            }}
          />
        </div>

        <Table
          data={data}
          mapData={videoReportTable}
          noDataMessage="No Report Found!"
        />

        <div className="mt-3">
          <Pagination
            totalItem={totalVideoReport}
            activePage={page}
            pageSize={size}
            onActivePageChange={handlePageChange}
            onPageSizeChange={handleRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
}
export default connect(null, {
  getVideoReport,
  deleteVideoReport,
})(VideoReport);
